import React from 'react';

import {
    Card, 
    CardContent,
    IconButton,
    Typography,
} from '@material-ui/core';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PortfolioCard(props) {
    const { portfolio, linkTo, setPortfolioToDelete } = props;
    return (
        <Card>
            <CardContent>
                <IconButton 
                    style={{float:'right'}}
                    onClick={() => setPortfolioToDelete(portfolio.id)}
                >
                    <FontAwesomeIcon icon={['fas','trash']} />
                </IconButton>
                <Link 
                    className='incubator-link-card' 
                    to={linkTo} 
                >
                    <div style={{ height: `200px` }}>
                        <Typography variant="h5" component="h2"  color='primary' className='incubator-card-name' gutterBottom>
                            {portfolio.name && portfolio.name}
                        </Typography>
                    </div>
                </Link>
            </CardContent>
        </Card>
    );
};